import { ReactNode, createContext, memo, useContext } from "react";

import { Box, SxProps, Tab, Tabs, styled } from "@mui/material";
import useLocalStorage from "../../hooks/useLocalStorage";

export const ChooseCodeLanguageContext = createContext<{
  language: string;
  setLanguage: (v: string) => void;
}>({
  language: "javascript",
  setLanguage: () => {},
});

export const ChooseCodeLanguageProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [codeLanguage, setCodeLanguage] = useLocalStorage<string>(
    "codeLanguage",
    "javascript"
  );
  //函数定义
  const scrollToAnchor = (anchorName: string) => {
    if (!anchorName) return;
    if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: "start", behavior: "auto" });
      }
    }
  };

  return (
    <ChooseCodeLanguageContext.Provider
      value={{
        language: codeLanguage,
        setLanguage: (v) => {
          setCodeLanguage(v);
          const hash = window.location.hash;
          scrollToAnchor(`${hash.replace("#", "")}`);
        },
      }}
    >
      {children}
    </ChooseCodeLanguageContext.Provider>
  );
};

const ChooseCodeLanguage = ({ sx }: { sx?: SxProps }) => {
  const { language, setLanguage } = useContext(ChooseCodeLanguageContext);
  return (
    <StylesWarp sx={{ ...sx }}>
      <Box>
        <Tabs
          value={language}
          onChange={(e, t) => {
            setLanguage(t);
          }}
        >
          <Tab label={"Java"} value={"java"} />
          <Tab label={"PHP"} value={"php"} />
          <Tab label={"Python"} value={"python"} />
          <Tab label={"Node"} value={"javascript"} />
          <Tab label={"Golang"} value={"go"} />
        </Tabs>
      </Box>
    </StylesWarp>
  );
};

const StylesWarp = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "24px",

  ".MuiTabs-flexContainer": {
    background: theme.palette.NightText.stroke,
    borderRadius: "8px",
    padding: "4px",
    flex: "auto",
    minHeight: "38px",
    ".MuiButtonBase-root": {
      minHeight: "32px",
      lineHeight: "32px",
      ":hover": {
        color: theme.palette.NightText.primary,
        fontWeight: 500,
      },
    },
    ".MuiTab-root": {
      padding: "4px 12px",
      marginRight: `0 !important`,
    },
    ".MuiTab-textColorInherit": {
      fontWeight: 500,
      color: theme.palette.NightText.secondary,
    },
    ".Mui-selected": {
      fontWeight: 500,
      color: theme.palette.NightText.primary,
      zIndex: 9,
    },
  },

  // 滑块
  ".MuiTabs-indicator": {
    height: "32px",
    zIndex: 1,
    borderRadius: "4px",
    top: "8px",
    backgroundColor: `${theme.palette.grey[900]} !important`,
  },
}));

export default memo(ChooseCodeLanguage);
